import "../../App.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import Table from "../Table";
import AutocompleteInputModule from "../AutoComplete";
import AgregarPersonaEmpresa from "./AgregarPersonaEmpresa";
import AutocompleteForms from "../AutocompleteForms";
import CurrentUser from "../CurrentUser";

function PersonaEmpresa(props) {
  const { history } = props;
  const [PersonaEmpresaState, setPersonaEmpresaState] = useState([]);
  const [PersonaEmpresaStateUpdate, setPersonaEmpresaStateUpdate] = useState(
    []
  );
  const [editable, setEditable] = useState("");
  const [filtrador, setFiltrador] = useState(0);
  const [autoCompletePersonaEmpresa, setAutoCompletePersonaEmpresa] = useState(
    []
  );
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [update, setUpdate] = useState(false);

  const [formularioState, setFormularioState] = useState({
    legal_id: "",
    legal_type: "J",
    full_name: "",
    first_name: "",
    last_name_1: "",
  });
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [countries, setCountries] = useState([]);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  const [paginas, setPaginas] = useState(0);

  // eslint-disable-next-line
  useEffect(async () => {
    let newForm = JSON.parse(JSON.stringify(formularioState));
    if (formularioState.full_name.split("/").length >= 2) {
      newForm.full_name = formularioState.full_name.split("/")[0];
      newForm.legal_id = formularioState.full_name.split("/")[1].split("-")[0];
    } else {
    }

    let response = await fetch(
      Parametros.urlApi +
        "persons/?is_mantenedor=true&skip=" +
        paginacionState.skip +
        "&limit=" +
        paginacionState.limit +
        "&legal_type=" +
        formularioState.legal_type,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        // eslint-disable-next-line
        body: JSON.stringify(newForm),
      }
    );

    if (response.status === 200 || response.status === 201) {
      let responseJson = await response.json();
      setPersonaEmpresaState(responseJson.data);

      setPersonaEmpresaStateUpdate(responseJson.data);
      setPaginas(responseJson.n_pages);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    }

    let respons2 = await fetch(
      Parametros.urlApi + "Countries?skip=0&limit=100",
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );

    if (respons2.status === 200 || respons2.status === 201) {
      let responseJson2 = await respons2.json();
      setCountries(responseJson2);
    }

    let response3 = await fetch(
      Parametros.urlApi +
        "persons/legal_id?legal_id=&legal_type=" +
        formularioState.legal_type,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );
    if (response3.status === 200 || response3.status === 201) {
      let data = await response3.json();
      setAutoCompletePersonaEmpresa(data);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update, paginacionState, formularioState.legal_type, usuario]);

  let asignarPersonaEmpresa = (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      history.push({
        pathname: "/AgregarSucursal",
        state: {
          item: JSON.stringify(item),
        },
      });
    } else {
      alert(usuario.editar);
    }
  };

  let handleStageForm = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    const name = event.target.getAttribute("name");

    if (event.target.type === "radio") {
      setFormularioState({
        legal_id: "",
        legal_type: value,
        full_name: "",
        first_name: "",
        last_name_1: "",
      });
      document.getElementById("formularioBusqueda").reset();
    } else {
      setFormularioState({
        ...formularioState,
        [name]: value,
      });
    }
  };

  let personaEmpresaHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");

    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = PersonaEmpresaState;
    newList[index][name] = value;

    newList[index][name] = value;

    setPersonaEmpresaState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let guardarUnidadEditada = async (item, index) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro de editar este elemento?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react
        let response = await fetch(
          Parametros.urlApi + "person/" + parseInt(item.person_uid),
          {
            method: "PUT",
            body: JSON.stringify(formularioUpdate),
            headers: {
              Authorization: "Bearer " + usuario.key,
              "Content-Type": "application/json",
              accept: "application/json",
            },
          }
        );
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setEditable({});
          alert(responseJson.message);
          setformularioUpdate({});
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setEditable({});
          setformularioUpdate({});
        }
      } else {
        // Do nothing!
        setPersonaEmpresaState(
          JSON.parse(JSON.stringify(PersonaEmpresaStateUpdate))
        );
      }
    } else {
      alert(usuario.editar);
    }
  };

  let cancelarEdicion = () => {
    setPersonaEmpresaState(
      JSON.parse(JSON.stringify(PersonaEmpresaStateUpdate))
    );
    setEditable({});
    setformularioUpdate({});
  };
  let editar = (id) => {
    setPersonaEmpresaState(
      JSON.parse(JSON.stringify(PersonaEmpresaStateUpdate))
    );
    setEditable(id);
    setformularioUpdate({});
  };

  let buscar = async (event) => {
    setUpdate(!update);
    event.preventDefault();

    // if (window.confirm('¿Esta seguro que deseas agregar este elemento?')) {
    //   // aqui deberia ir el delete segun response eliminar de la lista de react

    //   let newform = formularioState
    //

    //   countries.map((item) => {
    //     if (item.alias === newform.country_id) {
    //       newform.country_id = item.country_id
    //     }
    //   })

    //
    //   let response = await fetch(Parametros.post + "person/", {
    //     method: "POST",
    //     headers: {
    //       'Authorization': "Bearer " + usuario.key,
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json',
    //       'Origin': 'https://d1tl5p9wrfnj29.cloudfront.net/'
    //     },
    //     body: JSON.stringify(newform),
    //   })

    //
    //   let responseJson = await response.json()
    //

    //   if (response.status === 200 || response.status === 201) {
    //     alert("Se agrego correctamente")

    //     setUpdate(!update)
    //   } else {
    //     alert("responseJson")
    //   }
    // } else {
    //   // Do nothing!
    //   setPersonaEmpresaState(JSON.parse(JSON.stringify(PersonaEmpresaStateUpdate)))
    //   setEditable({})
    // }
  };

  // eslint-disable-next-line
  let eliminarElemento = async (index, item) => {
    if (usuario.permisos.indexOf("Eliminar") > -1) {
      if (window.confirm("¿Esta seguro de esta accion?")) {
        // aqui deberia ir el delete segun response eliminar de la lista de react

        let response = await fetch(
          Parametros.urlApi + "users/" + item.user_id,
          {
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert(responseJson.detail);

          let newList = PersonaEmpresaState;
          newList.splice(index, 1);
          setPersonaEmpresaState(JSON.parse(JSON.stringify(newList)));
          setPersonaEmpresaStateUpdate(JSON.parse(JSON.stringify(newList)));
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(JSON.stringify(responseJson.detail));
          setPersonaEmpresaState(
            JSON.parse(JSON.stringify(PersonaEmpresaState))
          );
          setEditable({});
        }
      } else {
        // Do nothing!
      }
    } else {
      alert(usuario.eliminar);
    }
  };

  const [modalState, setModalState] = useState(false);

  let ModalConfig = () => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      setModalState(!modalState);
    } else {
      alert(usuario.crear);
    }
  };

  return (
    <div className="App">
      <AgregarPersonaEmpresa
        update={update}
        setUpdate={setUpdate}
        legal_type={formularioState.legal_type}
        modalCondig={ModalConfig}
        setModal={setModalState}
        modalState={modalState}
      ></AgregarPersonaEmpresa>

      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Persona/Empresa"}></UserTab>
        <br></br>
        <form id="formularioBusqueda">
          <div className="form-check" onChange={handleStageForm}>
            <input
              className="form-check-input"
              type="radio"
              value="N"
              name="legal_type"
              onChange={handleStageForm}
              id="flexRadioDefault1"
              checked={formularioState.legal_type === "N"}
            ></input>
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Natural
            </label>
            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;
            <input
              className="form-check-input"
              type="radio"
              value="J"
              name="legal_type"
              onChange={handleStageForm}
              id="flexRadioDefault2"
              checked={formularioState.legal_type === "J"}
            ></input>
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              Juridica
            </label>
          </div>

          {formularioState.legal_type === "N" && (
            <>
              {/* <div className='col-md-3'>
                <h5>Nombres</h5>
                <input onChange={handleStageForm} name='first_name' className="form-control"></input>
              </div>


              <div className='col-md-3'>
                <h5>Apellido paterno</h5>
                <input onChange={handleStageForm} name='last_name_1' className="form-control"></input>
              </div> */}
              {/* 
              <div className='col-md-3'>
                <h5>Apellido materno</h5>
                <input onChange={handleStageForm} name='last_name_2'  className="form-control"></input>
              </div> */}
            </>
          )}

          <div className="col-md-9">
            {formularioState.legal_type === "J" ? (
              <h5>Empresa</h5>
            ) : (
              <h5>Nombre Completo</h5>
            )}
            <AutocompleteForms
              personalHandleChange={handleStageForm}
              value={formularioState.full_name}
              nameElement={"full_name"}
              formularioBuscado={formularioState}
              setformulario={setFormularioState}
              suggestions={autoCompletePersonaEmpresa.map((personaEmpresa) => {
                return {
                  value:
                    personaEmpresa.full_name +
                    "/" +
                    personaEmpresa.legal_id +
                    "-" +
                    personaEmpresa.verif_legal_id,
                  label:
                    personaEmpresa.full_name +
                    "/" +
                    personaEmpresa.legal_id +
                    "-" +
                    personaEmpresa.verif_legal_id,
                };
              })}
            />
          </div>

          {/* <div className='col-md-3'>
            <h5>Rut</h5>
            <input onChange={handleStageForm} name='legal_id' className="form-control"></input>
          </div>

          <div className='col-md-3'>
            <h5>Dígito verificador</h5>
            <input onChange={handleStageForm} name='verif_legal_id' className="form-control"></input>
          </div> */}

          <div className="col-md-3">
            <br />
            <button
              type="button"
              onClick={(e) => {
                buscar(e);
              }}
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Buscar
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ width: "100%" }}
        >
          <Table
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            type={1}
            paginationBelow={true}
            filtrador={filtrador}
            propsetFiltrador={setFiltrador}
            extraAction={
              <button
                type="button"
                onClick={() => ModalConfig()}
                className="btn btn-primary traspasarDeudasBtn"
              >
                Agregar
              </button>
            }
            elementos={[
              "País",
              formularioState.legal_type === "N"
                ? "Nombre Completo"
                : "Empresa",
              formularioState.legal_type === "N" ? "Nombres" : null,
              formularioState.legal_type === "N" ? "Apellido Paterno" : null,
              formularioState.legal_type === "N" ? "Apellido materno" : null,
              "Rut",
              "Dígito verificador",
              "Tipo de persona",
            ]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table
              type={2}
              filtrador={filtrador}
              propsetFiltrador={setFiltrador}
              elementos={[
                "País",
                formularioState.legal_type === "N"
                  ? "Nombre Completo"
                  : "Empresa",
                formularioState.legal_type === "N" && "Nombres",
                formularioState.legal_type === "N" && "Apellido Paterno",
                formularioState.legal_type === "N" && "Apellido materno",
                "Rut",
                "Dígito verificador",
                "Tipo de persona",
              ]}
            ></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {PersonaEmpresaState.map((item, index) => {
                  return (
                    <tr key={item.person_uid}>
                      {editable === item.person_uid ? (
                        <>
                          <th>{item.person_uid}</th>
                          <td>
                            <AutocompleteInputModule
                              suggestions={countries.map((item) => {
                                return {
                                  value: item.country_id,
                                  label: item.isocode3,
                                };
                              })}
                              value={item.country_id}
                              name={"country_id"}
                              setformularioUpdate={setformularioUpdate}
                              formularioUpdate={formularioUpdate}
                              setState={setPersonaEmpresaState}
                              i={index}
                              state={PersonaEmpresaState}
                            ></AutocompleteInputModule>
                          </td>

                          <td>
                            <input
                              value={item.full_name}
                              name="full_name"
                              onChange={(event) => {
                                personaEmpresaHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          {formularioState.legal_type === "N" ? (
                            <td>
                              <input
                                value={item.first_name}
                                name="first_name"
                                onChange={(event) => {
                                  personaEmpresaHandleChange(index, event);
                                }}
                                className="form-control"
                              ></input>
                            </td>
                          ) : null}

                          {formularioState.legal_type === "N" ? (
                            <td>
                              <input
                                value={item.last_name_1}
                                name="last_name_1"
                                onChange={(event) => {
                                  personaEmpresaHandleChange(index, event);
                                }}
                                className="form-control"
                              ></input>
                            </td>
                          ) : null}
                          {formularioState.legal_type === "N" ? (
                            <td>
                              <input
                                value={item.last_name_2}
                                name="last_name_2"
                                onChange={(event) => {
                                  personaEmpresaHandleChange(index, event);
                                }}
                                className="form-control"
                              ></input>
                            </td>
                          ) : null}

                          <td>{item.legal_id} </td>
                          <td>{item.verif_legal_id} </td>

                          {/* <td ><input value={item.legal_id} name='legal_id' onChange={(event) => { personaEmpresaHandleChange(index, event) }} className='form-control'></input></td>
                            <td ><input value={item.verif_legal_id} name='verif_legal_id' onChange={(event) => { personaEmpresaHandleChange(index, event) }} className='form-control'></input></td> */}
                          <td>
                            <div class="form-group">
                              <select
                                class="form-control"
                                name="legal_type"
                                value={item.legal_type}
                                onChange={(event) => {
                                  personaEmpresaHandleChange(index, event);
                                }}
                              >
                                <option value="N">N</option>
                                <option value="J">J</option>
                              </select>
                            </div>
                          </td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  guardarUnidadEditada(item, index);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion();
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <th>{item.person_uid}</th>
                          <td>
                            {countries.map((itemC) => {
                              if (itemC.country_id === item.country_id) {
                                return itemC.alias;
                              } else {
                                return "";
                              }
                            })}{" "}
                          </td>
                          <td>{item.full_name} </td>
                          {formularioState.legal_type === "N" && (
                            <td>{item.first_name}</td>
                          )}
                          {formularioState.legal_type === "N" && (
                            <td>{item.last_name_1} </td>
                          )}
                          {formularioState.legal_type === "N" && (
                            <td>{item.last_name_2}</td>
                          )}
                          <td>{item.legal_id} </td>
                          <td>{item.verif_legal_id} </td>
                          <td>{item.legal_type}</td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.person_uid);
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            {/* <abbr title="Eliminar Elemento"><span style={{ cursor: "pointer" }} onClick={() => { eliminarElemento(index, item) }} className='glyphicon glyphicon-remove'></span></abbr> */}
                            {formularioState.legal_type !== "N" && (
                              <abbr title="Asignar PersonaEmpresa">
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    asignarPersonaEmpresa(item);
                                  }}
                                  className="glyphicon glyphicon-plus "
                                ></span>
                              </abbr>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
      {/* {stateUptade &&
        <>
          <div className='container'>
            <div className='col-md-12'>
              <div className='col-md-3 col-md-offset-7' >
                <button className='btn btn-primary' onClick={() => { confirmarEliminacion() }}>Confrimar Actualizacion</button>
              </div>
              <div className='col-md-2'>
                <button className='btn btn-primary' onClick={() => { cancelarEliminacion() }}>Revertir cambios</button>
              </div>
            </div>
          </div>
        </>


      } */}
    </div>
  );
}

export default withRouter(PersonaEmpresa);
